import { ApartmentOutlined } from '@mui/icons-material';
import { Avatar, Divider, Link, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

type GroupsDetailsDrawerLocationsListItemProps = {
  location: { storeId: string; title: string };
};

const GroupsDetailsDrawerLocationsListItem = ({
  location,
}: GroupsDetailsDrawerLocationsListItemProps) => {
  const navigate = useNavigate();

  return (
    <Stack spacing={1} data-testid="GroupsLocationsList.Item" mb={1}>
      <Stack spacing={1} direction="row" alignItems="center">
        <Avatar variant="circular">
          <ApartmentOutlined />
        </Avatar>
        <Link
          variant="body2"
          sx={{ cursor: 'pointer' }}
          onClick={() => navigate(`../../../locations/${location?.storeId}`)}
          data-testid="GroupsLocationsList.Item.Link"
        >
          {location?.title}
        </Link>
      </Stack>
      <Divider />
    </Stack>
  );
};

export default GroupsDetailsDrawerLocationsListItem;
